// AutoAuto Pitstop Premium — theme.js

document.addEventListener('DOMContentLoaded', function () {

  // --- Mobile menu ---
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', isOpen);
    });
  }

  // --- Quantity buttons ---
  document.querySelectorAll('.product-qty').forEach(function (qty) {
    const input = qty.querySelector('.qty-input');
    qty.querySelector('[data-action="minus"]')?.addEventListener('click', function () {
      const val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
    qty.querySelector('[data-action="plus"]')?.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  // --- Cart AJAX add ---
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = '...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form))
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '✓';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
          // Update cart count
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              const countEl = document.querySelector('.cart-count');
              if (countEl) {
                countEl.textContent = cart.item_count;
                countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
              }
            });
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });

  // --- Gallery thumbnail switching ---
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const main = document.querySelector('.product-gallery__main');
      if (main) {
        main.src = thumb.src.replace('_150x', '_800x');
        document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
          t.style.borderColor = 'transparent';
        });
        thumb.style.borderColor = '#EC1313';
      }
    });
  });

});
